import { render, staticRenderFns } from "./LockerDeliveries.vue?vue&type=template&id=6217c042"
import script from "./LockerDeliveries.vue?vue&type=script&lang=js"
export * from "./LockerDeliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports